import { render, staticRenderFns } from "./FinalConfirm.vue?vue&type=template&id=1ca1dc4c&"
import script from "./FinalConfirm.vue?vue&type=script&lang=js&"
export * from "./FinalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FinalConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinalConfirm.vue"
export default component.exports